import { useQuery } from "@tanstack/react-query";
import {
  type GetSettlementPoolBoostsQueryResult,
  getSettlementPoolBoosts,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const SETTLEMENT_POOL_BOOSTS_QUERY_KEY = "SETTLEMENT_POOL_BOOSTS";

export const settlementPoolBoostKeys = {
  all: [SETTLEMENT_POOL_BOOSTS_QUERY_KEY] as const,
};

export const useGetSettlementPoolBoostsQuery = () =>
  useQuery<GetSettlementPoolBoostsQueryResult>({
    queryKey: settlementPoolBoostKeys.all,
    queryFn: processResponseWithApiProblemDetails(() =>
      getSettlementPoolBoosts(),
    ),
    refetchOnWindowFocus: false,
  });
